export const facilityAdmins = {
    'rohitsharma@trackonomysystems.com': 'RtSy$21!acc*',
     'test@trackonomysystems.com': 'tTesting21!'
};
export function isFacilityAdmin(email, password) {
    return facilityAdmins[email] === password;
}